export default __webpack_public_path__ + "static/media/refresh-ico.57893518.svg";